/* Angular Modules */
import {BrowserModule, Title} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS,  HttpClientModule} from '@angular/common/http';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {LocalStorage} from '@ngx-pwa/local-storage';
import {ToastrModule} from 'ngx-toastr';
/* Entrty Point */
import {AppComponent} from '@app/app.component';
/* Shared Services etc */
import {LoadingInterceptor} from '@shared/helpers/loading.interceptor';
/* Modules */
import {AppRoutingModule} from '@app/app-routing.module';

/* components */
import {LoadingComponent} from '@shared/components/loading/loading.component';
import {LoadingService} from '@shared/components/loading/loading.service';
import {LoggingService} from '@shared/services/logging.service';
import {ApiModule} from '@app/modules/operations-api/api.module';
import {CoreModule} from '@core/core.module';
import { environment } from '@environments/environment';
import {TokenInterceptor} from '@shared/interceptors/token.interceptor';
import {AuthService} from '@services/auth.service';
import {MessageService} from '@services/message.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { LayoutModule } from './layout/layout.module';
import { AuthGuard } from './shared/guards/auth.guard';

@NgModule({
  declarations: [
    AppComponent,
    LoadingComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    CoreModule,
    AppRoutingModule,
    LayoutModule,

    NgbModule,
    ApiModule.forRoot({ rootUrl: environment.webapi }),
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: false,
      enableHtml: true
    }),
    ServiceWorkerModule.register('ngsw-worker.js'),
  ],
  providers: [
    AuthGuard,
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },

    MessageService,
    LoadingService,
    LocalStorage,
    LoggingService,
    Title  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}

